
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

function applyRemissionActors(data) {
    const loggedUser = JSON.parse(localStorage.getItem('user') || 'null');

    if (!loggedUser?.id) {
        throw new Error('User ID no válido. Asegúrate de haber iniciado sesión.');
    }

    data.seller_id = loggedUser.id;

    if (data.client_id && !data.user_id) {
        data.user_id = data.client_id;
    }

    return data;
}

export default {
    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/remissions?${queryString}`; 

        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/remissions/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/remissions`, applyRemissionActors({ ...data }), { headers: authHeader() });
    },
    updateData(id, data) {
        const payload = { ...data };
        if (payload.client_id && !payload.user_id) {
            payload.user_id = payload.client_id;
        }
        delete payload.seller_id;
        return axios.put(`${API_URL}/remissions/${id}`, payload, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/remissions/${id}`, { headers: authHeader() });
    },
    getDoc(id) {
        return axios.get(`${API_URL}/remissions/export/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    getPdf(id, pdfData = null) {
        const params = {};
        if (pdfData) {
            params.tipo_pago  = pdfData.tipo_pago  ?? '';
            params.valor      = pdfData.valor       ?? '';
            params.obs        = pdfData.obs         ?? '';
            params.metodo     = pdfData.metodo      ?? '';
            params.mas_envio  = pdfData.mas_envio   ?? 'NO';
        }
        return axios.get(`${API_URL}/remissions/export-pdf/${id}`, { 
            headers: authHeader(), 
            responseType: 'blob',
            params 
        });
    },
    formalize(id) {
        return axios.post(`${API_URL}/remissions/${id}/formalize`, {}, { headers: authHeader() });
    },
    syncSiigo(id) {
        return axios.post(`${API_URL}/remissions/${id}/sync-siigo`, {}, { headers: authHeader() });
    },
};
